import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModeOfExecutionPipe } from './mode-of-execution.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ModeOfExecutionPipe
  ],
  exports: [
    ModeOfExecutionPipe
  ]
})
export class ModeOfExecutionModule { }
